<template>
  <div class="shape-toolbar-wrapper">
    <ColorSetting
      :key="componentKey"
      :currentColor="shapeStyle.background"
      class="color-setting"
      @changeColor="(color) => onUpdateShape('background', color)"
      @stopChangingColor="onStopChangeFillColor"
      v-tooltip="$i18nPresenter.t('Fill color')"
    />
    <AnimationToolbar />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventBus from '@/eventBus'
import ColorSetting from './editors/ColorSetting.vue'
import util from '@/util'
import eventCategories from '@/constant/eventCategories'
import AnimationToolbar from '@/components-v2/presentation-editor/middle/AnimationToolbar.vue'

export default {
  components: {
    AnimationToolbar,
    ColorSetting,
  },
  data() {
    return {
      componentKey: (new Date()).getTime(),
    }
  },
  computed: {
    ...mapState({
      selectingBlocks: (state) => state.selectingBlocks,
    }),
    shapeStyle() {
      if (this.selectingBlocks && this.selectingBlocks.length > 0) {
        return this.selectingBlocks[0].content.shapeStyle
      }
      return {
        background: '#4af',
      }
    },
  },
  watch: {
    shapeStyle: {
      handler() {
        this.componentKey = (new Date()).getTime()
      },
      immediate: true,
    },
  },
  methods: {
    onUpdateShape(cssProperty = 'background', cssValue = '#4af') {
      const newBlocks = this.selectingBlocks.map((block) => {
        if (block.type !== 'Shape') return block
        return {
          ...block,
          content: {
            ...block.content,
            shapeStyle: {
              ...block.content.shapeStyle,
              [`${cssProperty}`]: cssValue,
            },
          },
        }
      })
      EventBus.$emit('update-shape-blocks', newBlocks)
      util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Update shape', cssProperty, cssValue)
    },
    onStopChangeFillColor(color) {
      util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Update shape', 'background', color)
    },
  },
}
</script>

<style lang="scss" scoped>
.shape-toolbar-wrapper {
  @apply  h-full flex items-center justify-start rounded-lg;
  @apply bg-base-0;
  box-shadow: 0px 1px 3px 0px #0A0A0A1A;
}
.color-setting {
  @apply mr-1.5 ml-1;
}
</style>
